<template>
	<div>
		<p>Избрани снимки: {{ images.length }}</p>
	
		<draggable
		class="dragArea "
		:list="images"
		group="people"
		>
		<img 
		v-for="element in images"
		:key="element.id" class="card-img-top imgs-sortable" :src="element.icon" :alt="element.icon" @dblclick="deleteImage(element.id)">
		
	</draggable>
</div>
</template>


<script>

	import sortable from '../../mixins/sortable'	

	export default {
		name: 'sortable-images',
		props: {
			images: {
				type: Array,
			}
		},

		data() {
			return {
		
			};
		},
		mounted() {
			eventBus.$on('exportImages', (data) => {
               this.images.push({ 
					icon: data,
					id: this.idForList,
				})
				this.idForList++

          })
		},
		beforeDestroy() {
            eventBus.$off('exportImages')
        },
		watch: {
			images() {
				this.$emit('exportImages', this.images)
			}
		},
		methods: {
			deleteImage(id) {
				const index = this.images.findIndex((item) => item.id == id)
				this.images.splice(index, 1)
			},
			
		},
		mixins:[sortable],
		
	
	}
</script>

</script>

<style scoped>

.imgs-sortable  {
	margin: 0px 0px 4px 4px;
	height: 100px;
	width:auto;
}
.imgs-sortable img {
	    margin-bottom: 10px;
}
/*.sortable-images-ul li:first-child {
	width: 300px
}
.sortable-images-ul li {
}
.sortable-images-ul li {
	display: inline-block;
	}*/

</style>


// WEBPACK FOOTER //
// src/components/app_modules/SortableImages.vue